import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { findDevice } from '../_actions/user_action';
import setting from '../config/setting';

import { CustomOverlayMap, Map, MapMarker } from 'react-kakao-maps-sdk';

import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import '../css_admin/Overlay.css';

import MARKER_SRC_ONLINE from '../components/images/marker/marker_online.png';
import MARKER_SRC_OFFLINE from '../components/images/marker/marker_offline.png';
import MARKER_SRC_ERROR from '../components/images/marker/marker_error.png';
import MARKER_SRC_READY from '../components/images/marker/marker_ready.png';

const key = require('../config/key');

const MapContainer = (props) => {
    const dispatch = useDispatch();
    // console.log('MapContainer', props.userInfos);
    const userInfos = props.userInfos;

    const [isReady, setIsReady] = useState(false);
    const [overlayInfoList, setOverlayInfoList] = useState([]);

    const [activeOverlayId, setActiveOverlayId] = useState(null);

    const imageSize = { width: 20, height: 30 };
    const imageOption = { offset: { x: 18, y: 36 } };

    useEffect(() => {
        setIsReady(false);
        if (userInfos) {
            displayMap();
        }
    }, [userInfos]);

    const getAddressFromCoords = async (lat, lng) => {
        try {
            const response = await fetch(
                `https://dapi.kakao.com/v2/local/geo/coord2address.json?x=${lng}&y=${lat}&input_coord=WGS84`,
                {
                    method: "GET",
                    headers: {
                        "Authorization": `KakaoAK ${key.KAKAO_APP_KEY}`
                    }
                }
            );

            const data = await response.json();
            if (data.documents && data.documents.length > 0) {
                return data.documents[0].address.address_name;
            }
        } catch (error) {
            console.error("주소 변환 오류:", error);
        }
        return "";
    };

    const displayMap = async () => {
        setIsReady(false);
        try {
            const updatedOverlayInfoList = [];
        
            // 1) userInfos 순회
            for (const user of userInfos) {
                // 2) sensorNode 순회
                for (const sensorNode of user.sensorNode) {
                    // sensorNumber(value) 가 비어 있으면 스킵
                    if (!sensorNode.device) continue;
            
                    const body = {
                        id: user.email,
                        sensorNumber: sensorNode.value
                    };
            
                    try {
                        const response = await dispatch(findDevice(body));
                        if (!response.payload.findSuccess) continue;
            
                        const device = response.payload.deviceInfo;
            
                        // 상태에 따라 마커, 텍스트 결정
                        let markerImage = MARKER_SRC_READY;
                        let stateText   = "대기상태";
                        if (device.state === "Online") {
                            markerImage = MARKER_SRC_ONLINE;
                            stateText   = "온라인-정상동작";
                        } else if (device.state === "Offline") {
                            markerImage = MARKER_SRC_OFFLINE;
                            stateText   = "오프라인-점검필요";
                        } else if (device.state === "Error") {
                            markerImage = MARKER_SRC_ERROR;
                            stateText   = "데이터 에러-통신오류";
                        }
            
                        // 좌표 파싱 (fallback to user coords)
                        const lat = parseFloat(device.latitude)  || parseFloat(user.latitude);
                        const lng = parseFloat(device.longitude) || parseFloat(user.longitude);
            
                        // 주소 역지오코딩
                        const address = await getAddressFromCoords(lat, lng);
            
                        // 센서ID 마스킹
                        const rawId = device.sensorId || "";
                        const maskedSensorId =
                        rawId.length > 4
                            ? "*".repeat(rawId.length - 4) + rawId.slice(-4)
                            : rawId;
            
                        updatedOverlayInfoList.push({
                            mID:          device.id,
                            mLat:         lat,
                            mLng:         lng,
                            mAddress:     address,
                            mGateway:     user.sensorMain,
                            mSensor:      device.sensorNumber,
                            mSensorId:    maskedSensorId,
                            mState:       device.state,
                            mStateText:   stateText,
                            mMarkerImage: markerImage
                        });
                        console.log('displayMap - info:', device.id, user.sensorMain, device.sensorNumber);
                    } catch (err) {
                        console.error("장치 데이터 조회 오류:", err);
                    }
                }
            }
    
            // 3) 한 번에 state 업데이트
            const finalList = spreadOverlappingMarkers(updatedOverlayInfoList);
            setOverlayInfoList(finalList);
        } catch (err) {
            console.error("displayMap 전체 오류:", err);
        } finally {
            setIsReady(true);
        }
    };

    const EventOverlayContainer = ({ position, info }) => {
        // console.log('EventOverlayContainer', info);

        // const map = useMap();
        // const [isVisible, setIsVisible] = useState(false);
        const isVisible = activeOverlayId === info.mSensor;

        const totalAddress = info.mAddress;
        const arrayAddress = totalAddress.split(" ");
        let line1Address = arrayAddress[0] + " " + arrayAddress[1] + " " + arrayAddress[2];
        let line2Address = totalAddress.substring(line1Address.length);
        let line3Address = "";
        if (line2Address.indexOf('(') > 0 && line2Address.indexOf(')')) {
            const partAddress = line2Address;
            const arrayPart = partAddress.split("(");
            line2Address = arrayPart[0];
            line3Address = partAddress.substring(line2Address.length);
        }

        return (
            <>
            <MapMarker
                key={`${info.mID}-${info.mLat}-${info.mLng}`}
                position={position}
                image={{
                    src: info.mMarkerImage,
                    size: imageSize,
                    options: imageOption
                }}
                onClick={() => {
                    // setIsVisible((show) => (!show));
                    setActiveOverlayId(prev => prev === info.mSensor ? null : info.mSensor);
                }} />
                
                <CustomOverlayMap position={position}>
                {isVisible &&
                    <div className="mapMarkerPopup">
                        <div className="mapMarkerPopupLayer">
                            <div className="modalCloseIcon">
                                <div
                                    className="modalCloseIconImg"
                                    onClick={() => {
                                        // setIsVisible(false);
                                        setActiveOverlayId(null);
                                        props.setisdetail(false);
                                    }}></div>
                            </div>
                            <div>
                                <h2>{info.mSensor}</h2>
                            </div>
                            <div className="markerText">
                            {
                                info.mState === "Online" &&
                                <>
                                <FontAwesomeIcon icon={faLocationDot} style={{ color: '#75C03A', fontSize: '14px' }} />
                                </>
                            }
                            {
                                info.mState === "Offline" &&
                                <>
                                <FontAwesomeIcon icon={faLocationDot} style={{ color: '#DB2F18', fontSize: '14px' }} />
                                </>
                            }
                            {
                                info.mState === "Error" &&
                                <>
                                <FontAwesomeIcon icon={faLocationDot} style={{ color: '#F29729', fontSize: '14px' }} />
                                </>
                            }
                            {
                                info.mState === "" &&
                                <>
                                <FontAwesomeIcon icon={faLocationDot} style={{ color: '#BABABA', fontSize: '14px' }} />
                                </>
                            }
                                &nbsp;
                                <span>{info.mStateText}</span>
                            </div>
                            <hr />
                            <div className="PopuptextareaId">
                                <div className="PopuptextareaIdTitle">Gateway : </div>
                                <div className="PopuptextareaIdText">{info.mGateway}</div>
                            </div>
                            <div className="PopuptextareaLocation">
                                <div className="PopuptextareaIdTitle">Location : </div>
                                <div className="PopuptextareaIdText">{line1Address}</div>
                                <div className="PopuptextareaIdText">{line2Address}</div>
                                <div className="PopuptextareaIdText">{line3Address}</div>
                            </div>
                            <div className="mapMarkerPopupBtn">
                                <p onClick={(e) => handleDisplayDetail(e, info.mID)}>세부정보표시</p>
                            </div>
                        </div>
                    </div>
                }
                </CustomOverlayMap>
            </>
        );
    };

    const handleDisplayDetail = (e, info) => {
        console.log('handleDisplayDetail', info);

        props.setisdetail(true);
        props.setuserid(info);
    };

    // MapContainer Marker Spread
    // 1) 겹치는 마커 좌표를 작은 원으로 퍼뜨려 주는 헬퍼
    function spreadOverlappingMarkers(list) {
        // 1-1) 같은 좌표끼리 그룹핑
        const groups = list.reduce((acc, info) => {
            const key = `${info.mLat}_${info.mLng}`;
            (acc[key] = acc[key] || []).push(info);
            return acc;
        }, {});
            
        // 1-2) 그룹별로 퍼뜨리기
        const result = [];
        const radius = 0.0001; // 약 11m
        Object.values(groups).forEach(group => {
            if (group.length === 1) {
                result.push(group[0]);
            } else {
                const angleStep = (2 * Math.PI) / group.length;
                group.forEach((info, idx) => {
                    const angle = angleStep * idx;
                    const lat = parseFloat(info.mLat) + radius * Math.cos(angle);
                    const lng = parseFloat(info.mLng) + radius * Math.sin(angle);
                    result.push({ ...info, mLat: lat, mLng: lng });
                });
            }
        });
        return result;
    }

    return (
        <div>
            {
                isReady &&
                <Map
                    center={{
                        lat: setting.map_center_latitude,
                        lng: setting.map_center_longitude
                    }}
                    style={{
                        width: "100%",
                        height: "500px"
                    }}
                    level={setting.map_level}
                >
                    {
                        overlayInfoList.map((overlayInfo, index) => (
                            <EventOverlayContainer
                                key={`EventMarkerContainer-${overlayInfo.mLat}-${overlayInfo.mLng}-${index}`}
                                position={{ lat: overlayInfo.mLat, lng: overlayInfo.mLng }}
                                info={overlayInfo}
                            />
                        ))
                    }
                </Map>
            }
        </div>
    );        
};

export default MapContainer;
